(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Info-Banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const infoBanner = document.querySelector(".info-banner-main-container");
    const startCounting = () => {
      const counters = document.querySelectorAll(".info-banner-digits");
      counters.forEach(counter => {
        const updateCount = () => {
          const target = +counter.getAttribute("data-digit");
          const count = +counter.innerText;
          const increment = target / 500;
          if (count < target) {
            counter.innerText = Math.ceil(count + increment);
            setTimeout(updateCount, 90);
          } else {
            counter.innerText = target;
          }
        };
        updateCount();
      });
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          startCounting();
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(infoBanner);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Media-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const MediaBannerStripElement = document.querySelector('.MediaBannerStrip');
    let scrollAmount = 1;
    let animationId;
    function smoothScroll() {
      MediaBannerStripElement.scrollLeft += scrollAmount;
      if (MediaBannerStripElement.scrollLeft >= MediaBannerStripElement.scrollWidth - MediaBannerStripElement.clientWidth) {
        MediaBannerStripElement.scrollLeft = 0;
      }
      animationId = requestAnimationFrame(smoothScroll);
    }
    function startScrollAnimation() {
      animationId = requestAnimationFrame(smoothScroll);
    }
    function stopScrollAnimation() {
      cancelAnimationFrame(animationId);
    }
    MediaBannerStripElement.addEventListener('mouseenter', stopScrollAnimation);
    MediaBannerStripElement.addEventListener('mouseleave', startScrollAnimation);
    startScrollAnimation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-countdown-timer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const mycountdownData = document.getElementById("myCountdown");
    if (!mycountdownData) {
      console.error("Countdown element not found.");
      return;
    }

    const flashSaleEndDateTime = mycountdownData.getAttribute("data-end-date");
    const flashSaleDeadline = new Date(`${flashSaleEndDateTime}`).getTime();

    if (isNaN(flashSaleDeadline)) {
      console.error("Invalid date format.");
      return;
    }

    function formatTimeWithLeadingZero(number, digits = 2) {
      return number.toString().padStart(digits, "0");
    }

    function updateDisplay(timeString, className) {
      document.querySelectorAll(`.${className}`).forEach((element, index) => {
        element.textContent = timeString[index] || "0";
      });
    }

    function updateTimer() {
      const now = new Date().getTime();
      const timeRemaining = flashSaleDeadline - now;

      if (timeRemaining < 0) {
        updateDisplay("000", "day");
        updateDisplay("00", "hour");
        updateDisplay("00", "min");
        updateDisplay("00", "sec");
        return;
      }

      const flashSaleDays = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
      const flashSaleHours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const flashSaleMinutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const flashSaleSeconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

      const formattedDays = formatTimeWithLeadingZero(flashSaleDays, 3);
      const formattedHours = formatTimeWithLeadingZero(flashSaleHours);
      const formattedMinutes = formatTimeWithLeadingZero(flashSaleMinutes);
      const formattedSeconds = formatTimeWithLeadingZero(flashSaleSeconds);

      updateDisplay(formattedDays, "day");
      updateDisplay(formattedHours, "hour");
      updateDisplay(formattedMinutes, "min");
      updateDisplay(formattedSeconds, "sec");
    }

    setInterval(updateTimer, 1000);
    updateTimer();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cstm-featured-blog"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
    $('.cstm-blog__posts').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 1000,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
    responsive: [
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
    }
  }
      ]
  });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
     $(document).ready(function(){
  $('.cstmPoductGrid').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
    responsive: [
  {
    breakpoint: 1258,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      arrows: true,
    }
  },{
    breakpoint: 999,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true,
      arrows: true,
    }
  },
      {
    breakpoint: 768,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      arrows: true,
    }
  }

      ]
  });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  function calculateReadingTime(wordCount) {
    const wordsPerMinute = 900;
    const readingTimeMinutes = Math.ceil(wordCount / wordsPerMinute);
    return readingTimeMinutes;
  }

  document.addEventListener('DOMContentLoaded', function() {
    const articleElements = document.querySelectorAll('.article-content');
    articleElements.forEach(function(articleElement) {
      const wordCount = parseInt(articleElement.getAttribute('data-article-size'));
      const readingTime = calculateReadingTime(wordCount);
      
      const readingTimeElement = document.createElement('span');
      readingTimeElement.className = 'readingTime';
      readingTimeElement.innerText = `${readingTime} MIN READ`;
      articleElement.appendChild(readingTimeElement);
      console.log(`${readingTime} MIN READ`);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-Our-range"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
  $('.product-health-benefit-description-main').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplaySpeed: 1000,
  autoplay:true,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
  responsive: [
  {
  breakpoint: 989,
  settings: {
  arrows: true,
  slidesToScroll: 1,
  slidesToShow: 3,
  autoplay:true,

  }
  },
  {
  breakpoint: 768,
  settings: {
  arrows: true,
  slidesToScroll: 1,
  slidesToShow: 2,
  autoplay:true
  }
  }
  ]
  });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vollsateIn_section"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(){
  $('.test-slider').slick({
  centerMode: true,
  centerPadding: '20%',
  slidesToShow: 1,
  prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
  nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" width="25px" height="25px" viewBox="0 0 30.725 30.725" xml:space="preserve"><g><path d="M24.078,26.457c0.977,0.978,0.977,2.559,0,3.536c-0.488,0.488-1.128,0.731-1.77,0.731c-0.639,0-1.278-0.243-1.768-0.731   L5.914,15.362l14.629-14.63c0.977-0.977,2.559-0.976,3.535,0c0.977,0.977,0.977,2.56,0,3.536L12.984,15.362L24.078,26.457z"/></g></svg></button>',
  cssEase: 'ease',
  responsive: [
  {
  breakpoint: 1024,
  settings: {
  centerMode: true,
  centerPadding: '10%',
  slidesToShow: 1
  }
  },
  {
  breakpoint: 768,
  settings: {
  centerMode: true,
  centerPadding: '15%',
  slidesToShow: 1,
  dots: false,
  arrows: false
  }
  }

  ],
  onBeforeChange: function(slick, currentSlide, nextSlide) {
  $('.slick-slide').removeClass('slick-active slick-center');
  },
  onAfterChange: function(slick, currentSlide) {
  $('.slick-active').addClass('slick-center');
  },
  });
  });

  } catch(e) { console.error(e); }
})();
})();
